import(/* webpackMode: "eager" */ "/vercel/path0/fastpeps-core-storefront/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/fastpeps-core-storefront/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReferralProgramProvider"] */ "/vercel/path0/fastpeps-core-storefront/src/lib/context/referral-program-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/fastpeps-core-storefront/src/modules/common/components/localized-client-link/index.tsx");
